import { render, staticRenderFns } from "./Scoring.vue?vue&type=template&id=b438fd44&scoped=true&"
import script from "./Scoring.vue?vue&type=script&lang=js&"
export * from "./Scoring.vue?vue&type=script&lang=js&"
import style0 from "./Scoring.vue?vue&type=style&index=0&id=b438fd44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b438fd44",
  null
  
)

export default component.exports